module.exports = __webpack_public_path__ + "static/media/logo_en_white.80451b56.png";